export const redirectToLogin: () => void = () => {
  const url: URL = new URL(
    `${window.location.origin}/?mobileJoinNow=true&targetUri=${encodeURIComponent(
      window.location.pathname + window.location.search
    )}`
  );
  window.location.href = url.toString();
};

export const handleLoginClick: (isSemiLoggedIn: boolean, e?: React.MouseEvent) => void = (
  isSemiLoggedIn,
  event
) => {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  if (isSemiLoggedIn) {
    window.dispatchEvent(new CustomEvent('creditFullLoginClicked'));
  } else {
    window.dispatchEvent(new CustomEvent('loginClicked'));
  }
};
